import script from "./Fireworks.vue?vue&type=script&setup=true&lang=js"
export * from "./Fireworks.vue?vue&type=script&setup=true&lang=js"

import "./Fireworks.vue?vue&type=style&index=0&id=94a92a2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94a92a2a"]])

export default __exports__